export const menuData = [
    {title: 'Accueil', link: '/'},
    {title: 'A propos de nous', link: '/about'},
    {title: 'Locations', link: '/rentals'}
]